import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { pink } from '@mui/material/colors';
import { ShoppingCart } from 'react-feather';
import { formatNumber } from '../../utils';

function TotalOrders(props) {
  const userState = useSelector((state) => state.userReducer);
  const { counts } = userState;

  return (
    <Card {...props}>
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL ORDERS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {formatNumber(counts.orderCount)}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: pink[600],
                height: 56,
                width: 56,
              }}
            >
              <ShoppingCart />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default TotalOrders;
